import React from 'react';
import Heading from '../Heading';

/**
 * "Signing you in": the brief overlay components/OAuthCallback.jsx shows while it exchanges the
 * Google (Emergent) `#session_id=` for a session (SLOT_MODEL on; the legacy look stays for the
 * flag off). In the look of SiteDialog: a navy/70 scrim with a blur, a square paper panel with
 * the flat navy offset shadow, a Faustina 500 heading. The panel is a polite status region, so
 * screen readers hear "Signing you in. Please wait a moment." once. The spinner (a navy ring
 * with an orange arc) is decorative and turns only when motion is allowed; with reduced motion
 * it stays still and the words carry the state.
 *
 * Eager on purpose (it shows the moment the app starts on an OAuth return, and it is small):
 * one of the few components/site/auth files code outside the folder may import statically
 * (auth.imports.guard.test.js).
 */
export default function OAuthSigningIn() {
  return (
    <div
      className="site-light fixed inset-0 z-[100] grid place-items-center overflow-y-auto bg-navy/70 px-[15px] py-[19px] backdrop-blur-[5px]"
      data-oauth-signing-in=""
    >
      <div
        role="status"
        aria-live="polite"
        className="w-full max-w-[26rem] rounded-none border border-navy/25 bg-brand-paper px-[22px] py-8 text-center font-body text-navy shadow-[8px_10px_0] shadow-navy/50 nav:px-[35px]"
      >
        <img src="/tappd-logo.png" alt="" width="100" height="34" className="mx-auto block h-auto w-[100px]" />
        <span
          aria-hidden="true"
          className="mx-auto mt-7 block size-10 rounded-full border-4 border-navy/20 border-t-brand-orange motion-safe:animate-spin"
        />
        <Heading level={2} size="card" className="mt-6 hyphens-auto">
          Signing you in
        </Heading>
        <p className="mt-2 text-[0.9375rem] leading-relaxed text-brand-muted">Please wait a moment.</p>
      </div>
    </div>
  );
}
